module.exports = __webpack_public_path__ + "img/logo.66915b8b.png";